var x = /* @__PURE__ */ ((X) => (X[X.MAX = 1920] = "MAX", X[X.XXL = 1600] = "XXL", X[X.XL = 1200] = "XL", X[X.L = 960] = "L", X[X.M = 768] = "M", X[X.S = 600] = "S", X[X.XS = 480] = "XS", X[X.XXS = 360] = "XXS", X))(x || {});
//! Must be kept in sync with fe-core/core-styles/shared/_viewports.scss and ordered from highest to lowest
const S = ["xxl", "xl", "l", "m", "s", "xs", "xxs"];
export {
  x as Viewports,
  S as ViewportsSize
};
